import { render } from "./Serie.vue?vue&type=template&id=6a7432c2&scoped=true"
import script from "./Serie.vue?vue&type=script&lang=js"
export * from "./Serie.vue?vue&type=script&lang=js"

import "./Serie.vue?vue&type=style&index=0&id=6a7432c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7432c2"]])

export default __exports__